// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
const CONFIG = {
  slideTime: 5000,
  animationTime: 500, // when changed adapt in CSS also
}
export default class HeroController extends AdvancedController {



  static targets = [
    // TODO: use or remove
    // "exampleTarget",
    'image'
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
    imageIndex: {
      type: Number,
      default: 0
    }
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
    if (this.imageTargets.length > 0) {
      setTimeout(this.initialSlide.bind(this)) // first slide after half time
    }
  }

  moveSlide() {
    this.imageIndexValue = (this.imageIndexValue + 1) % this.imageTargets.length;

    if (this.imageTargets.length > 1) {
      this.imageTargets.forEach((div, index) => {

        if (index === this.imageIndexValue) {
          // div.classList.remove("-out")
          div.classList.add("-active")


        } else {
          if (div.classList.contains('-active')) {
            div.classList.add("-out")
            div.classList.remove("-active")
            setTimeout(() => {
              div.classList.remove("-out")
            }, CONFIG.animationTime * 2) // wait for animation to start, half time to crossfade
          }
        }
      })
      setTimeout(this.moveSlide.bind(this), CONFIG.slideTime)

    }
  }

  initialSlide() {

    const div = this.imageTargets[0];
    div.classList.add("-active")
    setTimeout(this.moveSlide.bind(this), CONFIG.slideTime);
  }


}
